var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgProfileLoginBlkRgb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 415.75 415.75",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,311.81 H 311.81 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 415.75)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(121.29 125.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-11.741 6.382c-0.51 0.275-1.138 0.239-1.606-0.105-20.316-14.834-33.554-38.815-33.554-65.841v-23.219c0-0.819 0.664-1.482 1.482-1.482h11.851c0.818 0 1.481 0.663 1.481 1.482v23.219c0 24.123 12.882 45.289 32.126 57.001 0.981 0.598 0.972 2.014-0.039 2.563"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(203.86 131.64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.469 0.344-1.097 0.38-1.605 0.104l-11.743-6.381c-1.009-0.549-1.018-1.965-0.038-2.564 19.243-11.712 32.125-32.878 32.125-57.001v-23.219c0-0.818 0.661-1.481 1.482-1.481h11.851c0.818 0 1.482 0.663 1.482 1.481v23.219c0 27.027-13.239 51.008-33.554 65.842"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.91 147.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-29.951 0-54.317 24.368-54.317 54.316 0 29.951 24.366 54.32 54.317 54.32 29.95 0 54.316-24.369 54.316-54.32 0-29.948-24.366-54.316-54.316-54.316m69.131 54.316c0 38.122-31.012 69.134-69.131 69.134s-69.131-31.012-69.131-69.134c0-38.119 31.012-69.13 69.131-69.13s69.131 31.011 69.131 69.13"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLoginBlkRgb);
export default __webpack_public_path__ + "static/media/Profile_Login_BLK_RGB.d54eab7d79c01d746069a45a5ff616ad.svg";
export { ForwardRef as ReactComponent };